import PropTypes from 'prop-types';
import React from 'react';
import { Grid } from '@material-ui/core';
import { Minus, Plus } from 'react-feather';
import TextField from '../TextField';
import Button from '../../Button';

const Row = ({
    item,
    addItem,
    removeItem,
    disableRemove,
    updateLabel,
    updateValue,
}) => {
    const { label, value } = item;
    return (
        <Grid
            key={`row-${value}`}
            direction="row"
            container
            flex
            spacing={1}
            alignItems="center"
            justifyContent="center"
        >
            <Grid item xs={5}>
                <TextField
                    key={`${item.id}-label`}
                    id="label"
                    name="label"
                    type="text"
                    placeholder="label"
                    variant="outlined"
                    fullWidth
                    style={{ marginBottom: 0 }}
                    onChange={(event) => updateLabel(item, event.target.value)}
                    value={label}
                    autoFocus={true}
                />
            </Grid>
            <Grid item xs={3}>
                <TextField
                    key={`${item.id}-value`}
                    id="value"
                    name="value"
                    type="text"
                    placeholder="value"
                    variant="outlined"
                    fullWidth
                    style={{ marginBottom: 0 }}
                    onChange={(event) => updateValue(item, event.target.value)}
                    value={value}
                    autoFocus={true}
                />
            </Grid>
            <Grid item xs={2} align="center">
                {/* <Checkbox /> */}
            </Grid>
            <Grid item xs={1} align="center">
                <Button
                    onClick={() => addItem(item)}
                    style={{ padding: '10px', minWidth: '40px' }}
                    variant="contained"
                >
                    <Plus size={14} />
                </Button>
            </Grid>
            <Grid item xs={1} align="center">
                <Button
                    onClick={() => removeItem(item)}
                    style={{ padding: '10px', minWidth: '40px' }}
                    variant="contained"
                    disabled={disableRemove}
                >
                    <Minus size={14} />
                </Button>
            </Grid>
        </Grid>
    );
};

export default Row;

Row.propTypes = {
    addItem: PropTypes.func.isRequired,
    disableRemove: PropTypes.bool,
    item: PropTypes.object.isRequired,
    removeItem: PropTypes.func,
    updateLabel: PropTypes.func,
    updateValue: PropTypes.func,
};

Row.defaultProps = {
    disableRemove: false,
};
